var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Information, Success, Warning, WarningTriangle } from '../../foundations/icons';
import { Typography } from '../../foundations/typography';
import styles from './Alert.module.scss';
import { logDeprecationMessage } from '../../utils/logDeprecationMessage';
/**
 * @tdr
 * @tdr-deprecated-props: ariaLive,children,dataTest,titleComponent
 * @tdr-deprecated-date: 2022-06-16
 */
export function Alert(_a) {
    var _b, _c;
    var children = _a.children, dataTest = _a.dataTest, title = _a.title, titleComponent = _a.titleComponent, message = _a.message, _d = _a.type, type = _d === void 0 ? 'error' : _d, _e = _a.ariaLive, ariaLive = _e === void 0 ? false : _e, actions = _a.actions, props = __rest(_a, ["children", "dataTest", "title", "titleComponent", "message", "type", "ariaLive", "actions"]);
    var isTitleString = typeof title === 'string';
    if (title && !isTitleString && titleComponent) {
        logDeprecationMessage('Alert component: Using deprecated titleComponent prop combined with a custom title component via "title" prop will have no effect.');
    }
    var ariaProps = ariaLive
        ? {
            role: 'alert',
            'aria-live': 'polite',
        }
        : {};
    var dataTestMessage;
    var Icon;
    switch (type) {
        case 'error':
            Icon = Warning;
            dataTestMessage = 'errorMessage';
            break;
        case 'info':
            Icon = Information;
            dataTestMessage = 'infoMessage';
            break;
        case 'warning':
            Icon = WarningTriangle;
            dataTestMessage = 'warningMessage';
            break;
        default:
            Icon = Success;
            dataTestMessage = 'successMessage';
    }
    dataTestMessage = dataTest || dataTestMessage;
    return (React.createElement("div", __assign({ className: classNames(styles.alert, (_b = {},
            _b[styles.error] = type === 'error',
            _b[styles.info] = type === 'info',
            _b[styles.success] = type === 'success',
            _b[styles.warning] = type === 'warning',
            _b)), "data-test": dataTestMessage }, ariaProps, props),
        React.createElement(Icon, { size: "large", className: classNames(styles.icon, (_c = {},
                _c[styles.titleOnly] = !!title && !message && !children,
                _c)) }),
        React.createElement("div", { className: styles.content },
            isTitleString ? (React.createElement(Typography, { noMargins: true, styleAs: "paragraphHeading", element: titleComponent, "data-test": "alertTitle" }, title)) : (title),
            typeof message === 'string' ? (React.createElement(Typography, { noMargins: true, "data-test": "alertMessage" }, message)) : (message),
            !!children && (React.createElement(Typography, { noMargins: true, "data-test": "alertChildren" }, children))),
        !!actions && React.createElement("div", { className: styles.actions }, actions)));
}
//# sourceMappingURL=Alert.js.map